import { createThemeStore, type ThemeConfig } from "@jkast90/kast-common/theme";

/** Light, dark or follow the system (the default), saved per browser under the key it has always had. */
export const themeConfig: ThemeConfig = {
  storageKey: "salvagers_theme",
  themes: [
    { id: "light", label: "Light", scheme: "light", color: "#f6f5f1" },
    { id: "dark", label: "Dark", scheme: "dark", color: "#0b0b10" },
  ],
};

export const themeStore = createThemeStore(themeConfig);
